import { render, staticRenderFns } from "./TwoNews.vue?vue&type=template&id=7f422064"
import script from "./TwoNews.vue?vue&type=script&lang=js"
export * from "./TwoNews.vue?vue&type=script&lang=js"
import style0 from "./TwoNews.vue?vue&type=style&index=0&id=7f422064&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports